import React from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-loading";
import "leaflet-loading/src/Control.Loading.css";

const useLeafletLoading: React.FC = (): null => {
  const leafletMap = useMap();

  React.useEffect(() => {
    if (!leafletMap) return;

    const loadingControl = L.Control.loading({
      separate: true,
      position: "topleft",
      delayIndicator: 0,
      zoomControl: undefined,
      spinjs: false,
    });

    leafletMap.addControl(loadingControl);
  }, [leafletMap]);

  return null;
};

export default useLeafletLoading;

// export const MapEventsHandler = (): null => {
//   const handleMapClick = (e: L.LeafletMouseEvent): void => {
//     const { lat, lng } = e.latlng;
//     console.log(`Clicked at: ${lat}, ${lng}`);
//   };

//   useMapEvents({
//     click: (e) => handleMapClick(e),
//   });

//   useMapEvent("click", handleMapClick);

//   return null;
// };
